/**
 * Phase 16a (ADR-0023): the bireysel edition's words, kept apart from tr.ts and en.ts (merged in index.ts under
 * `b2c`): the plan in the shell, the limits' cards (B2cTokenBitti, B2cGunlukBitti, B2cDosyaBoyutu, B2cBelgeSiniri,
 * B2cBaglantilar) and Ayarlar › Abonelik. Turkish first; the English mirrors it key for key. A Turkish ending after a
 * number or a unit is written after an apostrophe only where the unit fixes it ("MB'a", "00:00'da").
 */
export const b2cTr = {
  b2c: {
    chip: {
      free: 'Ücretsiz paket',
      upgrade: 'Pro’ya geç',
      label: 'Ücretsiz paket, Pro’ya geç',
      pro: 'Pro',
      proLabel: 'Pro paket',
    },
    offer: {
      title: 'Pro yakında',
      body: 'Pro’ya geçiş çok yakında burada açılıyor. O zamana kadar Ücretsiz paketle devam edebilirsiniz; sohbetleriniz ve belgeleriniz olduğu gibi kalır.',
      compare: 'Paketler',
      feature: 'Özellik',
      price: 'Fiyat (KDV dahil)',
      monthly: '{{price}} / ay',
      yearly: 'yıllık {{price}}',
      free: '0 TL',
      dailyTokens: 'Günlük token',
      documents: 'Belge sayısı',
      fileSize: 'Dosya boyutu',
      fileSizeValue: 'en çok {{mb}} MB',
      connections: 'Kendi bağlantıları (MCP)',
      yes: 'Var',
      no: 'Yok',
      close: 'Tamam',
    },
    allowance: {
      freeTitle: 'Bugünkü ücretsiz hakkınız doldu.',
      freeBody: '{{plan}} pakette günde {{limit}} token var. Hakkınız gece <b>00:00</b>’da yenilenir; sorunuz burada bekler, kaldığınız yerden devam edersiniz. Beklemek istemezseniz Pro’ya geçin: günde {{pro}} token.',
      freeBodyNoOffer: '{{plan}} pakette günde {{limit}} token var. Hakkınız gece <b>00:00</b>’da yenilenir; sorunuz burada bekler, kaldığınız yerden devam edersiniz.',
      proTitle: 'Bugünkü sınırınız doldu.',
      proBody: 'Pro’da günde en çok {{limit}} token kullanılır. Sınır gece <b>00:00</b>’da açılır; sorunuz burada bekler.',
      today: 'Bugün',
      use: '<b>{{used}}</b> / {{limit}} token',
      useLabel: 'Bugün {{used}} / {{limit}} token',
      resetFree: 'Gece 00:00’da yenilenir',
      resetPro: 'Gece 00:00’da açılır',
      upgrade: 'Pro’ya geç · {{price}}/ay',
      upgradePlain: 'Pro’ya geç',
      compare: 'Paketleri karşılaştır',
      usage: 'Kullanımım',
      waited: 'Günlük hak dolduğu için bu soru bekledi.',
      placeholderFree: 'Hakkınız gece 00:00’da yenilenir',
      placeholderPro: 'Sınır gece 00:00’da açılır',
    },
    oversize: {
      chip: '{{size}} · sınırın üstünde',
      free: 'Bu dosya {{size}}. {{plan}} pakette dosyalar en çok {{limit}} MB olabilir; Pro’da {{pro}} MB’a kadar.',
      freeNoOffer: 'Bu dosya {{size}}. {{plan}} pakette dosyalar en çok {{limit}} MB olabilir.',
      pro: 'Bu dosya {{size}}. Dosyalar en çok {{limit}} MB olabilir.',
      remove: '{{name}} dosyasını kaldır',
      upgrade: 'Pro’ya geç',
    },
    documents: {
      count: '{{count}} / {{limit}} belge · {{plan}}',
      footer: '{{plan}} pakette en çok {{limit}} belge saklanır; dosyalar en çok {{mb}} MB olabilir.',
      over: 'Belgeleriniz {{plan}} paketin sınırının üstünde ({{count}} / {{limit}}): sınırın altına inene kadar yeni belge yüklenmez. Hiçbir belge silinmedi.',
      limitTitle: 'Belge sınırına ulaştınız',
      limitNamed: '{{plan}} pakette en çok {{limit}} belge saklanır. <b>{{name}}</b> dosyasını yüklemek için belgelerinizden birini silin ya da Pro’ya geçin.',
      limitPlain: '{{plan}} pakette en çok {{limit}} belge saklanır. Yeni belge yüklemek için belgelerinizden birini silin ya da Pro’ya geçin.',
      limitNamedNoOffer: '{{plan}} pakette en çok {{limit}} belge saklanır. <b>{{name}}</b> dosyasını yüklemek için belgelerinizden birini silin.',
      limitPlainNoOffer: '{{plan}} pakette en çok {{limit}} belge saklanır. Yeni belge yüklemek için belgelerinizden birini silin.',
      limitPro: 'Pro’da en çok {{limit}} belge saklanır. Yeni belge yüklemek için belgelerinizden birini silin.',
      proInfo: 'Pro’da {{limit}} belge saklanır; dosyalar {{mb}} MB’a kadar olabilir.',
      manage: 'Belgelerimi yönet',
      close: 'Kapat',
    },
    connections: {
      title: 'Kendi bağlantılarınız Pro’da',
      body: 'Pro’da kendi MCP sunucularınızı bağlarsınız; Oppy onların araçlarını sohbette kullanır. Örneğin not uygulamanız, kod deponuz ya da takviminiz.',
      steps: {
        address: { title: 'Adresi girin', body: 'Bağlanmak istediğiniz MCP sunucusunun adresini yazarsınız.' },
        signIn: { title: 'Hesabınızla bağlanın', body: 'Gerekirse o hizmetin kendi giriş ekranında izin verirsiniz.' },
        use: { title: 'Sohbette kullanın', body: 'Oppy o hizmetin araçlarını kullanır; önemli işlemlerden önce size sorar.' },
      },
      secure: 'Anahtarlarınız ve oturumlarınız sunucuda şifreli saklanır.',
      kept: 'Bağlantılarınız silinmedi; Pro’ya dönünce yeniden açılır.',
      tag: 'Pro’da',
    },
    subscription: {
      section: 'Abonelik',
      plan: 'Paketiniz',
      active: 'Etkin',
      free: '{{plan}}',
      proUntil: 'Pro · {{date}} tarihine kadar',
      upgradeSoon: 'Pro’ya geçiş yakında burada açılıyor.',
      upgrade: 'Pro’ya geç',
      usage: 'Kullanım',
      today: 'Bugün',
      todayValue: '{{used}} / {{limit}} token',
      reset: 'Gece 00:00’da sıfırlanır',
      noMonthly: 'Aylık sınır yok; hak her gece yenilenir.',
      documents: 'Belgeler',
      documentsValue: '{{count}} / {{limit}}',
      fileSize: 'Dosya başına en çok {{mb}} MB',
      connections: 'Kendi bağlantılarınız',
      connectionsOn: '{{count}} bağlantı',
      connectionsPro: 'Pro’da',
      connectionsLink: 'Bağlantılar',
      loading: 'Kullanım okunuyor…',
    },
    role: {
      free: 'Ücretsiz paket',
      pro: 'Pro',
    },
  },
};

export const b2cEn: typeof b2cTr = {
  b2c: {
    chip: {
      free: 'Free plan',
      upgrade: 'Go Pro',
      label: 'Free plan, go Pro',
      pro: 'Pro',
      proLabel: 'Pro plan',
    },
    offer: {
      title: 'Pro is coming soon',
      body: 'Going Pro opens here very soon. Until then you can go on with the Free plan; your conversations and documents stay as they are.',
      compare: 'Plans',
      feature: 'Feature',
      price: 'Price (VAT included)',
      monthly: '{{price}} / month',
      yearly: '{{price}} a year',
      free: '0 TL',
      dailyTokens: 'Tokens a day',
      documents: 'Documents',
      fileSize: 'File size',
      fileSizeValue: 'up to {{mb}} MB',
      connections: 'Own connections (MCP)',
      yes: 'Yes',
      no: 'No',
      close: 'OK',
    },
    allowance: {
      freeTitle: 'Today’s free allowance is used up.',
      freeBody: 'The {{plan}} plan has {{limit}} tokens a day. It renews at <b>00:00</b> tonight; your question waits here and goes on from where it stopped. If you would rather not wait, go Pro: {{pro}} tokens a day.',
      freeBodyNoOffer: 'The {{plan}} plan has {{limit}} tokens a day. It renews at <b>00:00</b> tonight; your question waits here and goes on from where it stopped.',
      proTitle: 'Today’s limit is reached.',
      proBody: 'Pro uses at most {{limit}} tokens a day. The limit opens at <b>00:00</b> tonight; your question waits here.',
      today: 'Today',
      use: '<b>{{used}}</b> / {{limit}} tokens',
      useLabel: 'Today {{used}} / {{limit}} tokens',
      resetFree: 'Renews at 00:00 tonight',
      resetPro: 'Opens at 00:00 tonight',
      upgrade: 'Go Pro · {{price}}/month',
      upgradePlain: 'Go Pro',
      compare: 'Compare plans',
      usage: 'My usage',
      waited: 'This question waited because the daily allowance was used up.',
      placeholderFree: 'Your allowance renews at 00:00 tonight',
      placeholderPro: 'The limit opens at 00:00 tonight',
    },
    oversize: {
      chip: '{{size}} · over the limit',
      free: 'This file is {{size}}. On the {{plan}} plan files can be at most {{limit}} MB; on Pro up to {{pro}} MB.',
      freeNoOffer: 'This file is {{size}}. On the {{plan}} plan files can be at most {{limit}} MB.',
      pro: 'This file is {{size}}. Files can be at most {{limit}} MB.',
      remove: 'Remove {{name}}',
      upgrade: 'Go Pro',
    },
    documents: {
      count: '{{count}} / {{limit}} documents · {{plan}}',
      footer: 'The {{plan}} plan keeps at most {{limit}} documents; files can be at most {{mb}} MB.',
      over: 'Your documents are over the {{plan}} plan’s limit ({{count}} / {{limit}}): no new document can be added until you have fewer. Nothing was deleted.',
      limitTitle: 'You reached the document limit',
      limitNamed: 'The {{plan}} plan keeps at most {{limit}} documents. To add <b>{{name}}</b>, delete one of your documents or go Pro.',
      limitPlain: 'The {{plan}} plan keeps at most {{limit}} documents. To add a new one, delete one of your documents or go Pro.',
      limitNamedNoOffer: 'The {{plan}} plan keeps at most {{limit}} documents. To add <b>{{name}}</b>, delete one of your documents.',
      limitPlainNoOffer: 'The {{plan}} plan keeps at most {{limit}} documents. To add a new one, delete one of your documents.',
      limitPro: 'Pro keeps at most {{limit}} documents. To add a new one, delete one of your documents.',
      proInfo: 'Pro keeps {{limit}} documents; files can be up to {{mb}} MB.',
      manage: 'Manage my documents',
      close: 'Close',
    },
    connections: {
      title: 'Your own connections are on Pro',
      body: 'On Pro you connect your own MCP servers; Oppy uses their tools in the chat. For example your notes app, your code repository or your calendar.',
      steps: {
        address: { title: 'Enter the address', body: 'You type the address of the MCP server you want to connect.' },
        signIn: { title: 'Sign in with your account', body: 'If needed, you allow it on that service’s own sign-in page.' },
        use: { title: 'Use it in the chat', body: 'Oppy uses that service’s tools; it asks you before important actions.' },
      },
      secure: 'Your keys and sign-ins are kept encrypted on the server.',
      kept: 'Your connections were not deleted; they open again with Pro.',
      tag: 'On Pro',
    },
    subscription: {
      section: 'Subscription',
      plan: 'Your plan',
      active: 'Active',
      free: '{{plan}}',
      proUntil: 'Pro · until {{date}}',
      upgradeSoon: 'Going Pro opens here soon.',
      upgrade: 'Go Pro',
      usage: 'Usage',
      today: 'Today',
      todayValue: '{{used}} / {{limit}} tokens',
      reset: 'Resets at 00:00 tonight',
      noMonthly: 'No monthly limit; the allowance renews every night.',
      documents: 'Documents',
      documentsValue: '{{count}} / {{limit}}',
      fileSize: 'At most {{mb}} MB per file',
      connections: 'Your own connections',
      connectionsOn: '{{count}} connections',
      connectionsPro: 'On Pro',
      connectionsLink: 'Connections',
      loading: 'Reading your usage…',
    },
    role: {
      free: 'Free plan',
      pro: 'Pro',
    },
  },
};
